import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faEdit, faTrash, faGripHorizontal, faDownload, faBarcode, faEnvelopeOpen, faCheck, faEuroSign, faFileDownload, faBriefcaseMedical, faAddressCard, faSave, faTasks, faArchive, faBoxOpen, faDiagnoses, faStethoscope, faStepBackward, faCogs, faMoneyBillWave, faVial, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSearch, faEdit, faTrash, faGripHorizontal, faDownload,
  faBarcode, faEnvelopeOpen, faCheck, faEuroSign, faFileDownload,
  faBriefcaseMedical, faAddressCard, faSave, faTasks, faArchive,
  faBoxOpen, faDiagnoses, faStethoscope, faStepBackward, faCogs,
  faMoneyBillWave, faVial, faExclamationTriangle);

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default FontAwesomeIcon;
